import { OvertimeComponent } from "../../components";

export default function OvertimeRegistrationDataPage() {
  return <OvertimeComponent.OvertimeRegistrationDataList />;
}
